import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/facilitator-calls';
const CLASSIFICATION_ENDPOINT = '/call-result-classifications';

export class FacilitatorCallsService extends RestServiceConnection {
    listTotalCalls = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-total-calls',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    listSystemFacilitators = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-system-facilitators',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    getDashboardAssignments = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/dashboard-assignments',
        }, true) as AxiosResponse;
        return this;
    };

    getContractSummary = async (contractId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-contract-summary',
            data: { contractId },
        }, true) as AxiosResponse;
        return this;
    };

    getContractExtras = async (contractId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-contract-extras',
            data: { contractId },
        }, true) as AxiosResponse;
        return this;
    };

    lookupExtraStudent = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/lookup-extra-student',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    saveContractExtraObservation = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/save-contract-extra-observation',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    createContractExtra = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create-contract-extra',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    listPendingContractExtras = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-pending-contract-extras',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    markContractExtraDone = async (extraId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/mark-contract-extra-done',
            data: { extraId },
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    listContractTracking = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-contract-tracking',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    createContractTracking = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create-contract-tracking',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    listScheduled = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-scheduled',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    };

    sendContractEmail = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/send-contract-email',
            data,
            headers: { 'Content-Type': 'application/json' },
        }, true) as AxiosResponse;
        return this;
    };

    listClassificationOptions = async () => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLASSIFICATION_ENDPOINT + '/list-for-select',
            data: {},
        }, true) as AxiosResponse;
        return this;
    };
}
